import { createSlice } from '@reduxjs/toolkit';

import type { WorkOrder } from './types';

export const slice = createSlice({
    initialState: {
        workOrder: null as WorkOrder | null
    },

    name: 'useWorkOrder',

    reducers: {
        workOrder: (state, action) => {
            state.workOrder = action.payload;
        }
    }
});

export default slice.reducer;
